import { render, staticRenderFns } from "./bets.vue?vue&type=template&id=536d2ae0&"
import script from "./bets.vue?vue&type=script&lang=js&"
export * from "./bets.vue?vue&type=script&lang=js&"
import style0 from "./bets.vue?vue&type=style&index=0&id=536d2ae0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports